import { createContext } from 'react';

import { FormStructureState } from './form-structure.model';

export const FormStructureContext = createContext<FormStructureState | undefined>(undefined);

FormStructureContext.displayName = 'FormStructureContext';
